import {
  getAdminPermissionsForRoles,
  type AdminPermission,
  type AdminRole,
} from "../../contracts/admin-permissions";
import type { AdminQueryPort } from "../../contracts/admin-query-port";
import {
  createAdminAuthSession,
  type AdminAuthSession,
  type AdminFixtureSession,
} from "../../shared/auth/admin-auth-session";
import { createAdminQueryClient } from "./create-admin-query-client";
import type { AdminDashboardRuntimeConfig } from "./admin-dashboard-runtime-config";

export type AdminDashboardDependencies = {
  runtimeConfig: AdminDashboardRuntimeConfig;
  adminSession: AdminAuthSession;
  queryPort: AdminQueryPort;
  adminRoles: AdminRole[];
  adminPermissions: AdminPermission[];
};

export type CreateAdminDashboardDependenciesOptions = {
  fixtureSession?: AdminFixtureSession;
  getAccessToken?: () => Promise<string | undefined> | string | undefined;
};

export function createAdminDashboardDependencies(
  config: AdminDashboardRuntimeConfig,
  options?: CreateAdminDashboardDependenciesOptions,
): AdminDashboardDependencies {
  const adminSession = createAdminAuthSession({
    authMode: config.authMode,
    runtimeRoles: config.adminRoles,
    fixtureSession: options?.fixtureSession,
    getAccessToken: options?.getAccessToken,
  });

  return {
    runtimeConfig: config,
    adminSession,
    queryPort: createAdminQueryClient(config, adminSession),
    adminRoles: adminSession.roles,
    adminPermissions: getAdminPermissionsForRoles(adminSession.roles),
  };
}
